import { render } from "./margin.vue?vue&type=template&id=5274d3aa"
import script from "./margin.vue?vue&type=script&lang=js"
export * from "./margin.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__